import styles from './MainNavbar.module.css';
import NavbarLogo from '../../assets/logos/inery_navigation_logo.webp';
import { useContext, useState } from 'react';
import ThemeContext from 'config/context/themeContext';
import { MenuIcon } from 'features/navigation/assets/icons/icons';
import { NavLink } from 'react-router-dom';
import { navigationConfig } from 'features/navigation/config/navigationConfig';
import MainNavbarAccount from './MainNavbarAccount';

const MainNavbar = () => {
    const { dark } = useContext(ThemeContext);
    const [menu, setMenu] = useState(false);
    return (
        <div className={`${styles.main_navbar} ${dark ? styles.dark : ""}`}>
            <div className={styles.container}>
                <div className={styles.logo}>
                    <NavLink to="/"><img src={NavbarLogo} alt="Inery" /></NavLink>
                    <span>Inery DB GUI</span>
                </div>
                <button onClick={() => setMenu(true)} className={styles.menu_toggler_btn}><MenuIcon color={dark ? "#E0E0E0" : ""} /></button>
                <div className={`${styles.main_navbar_menu} ${menu ? styles.menu_open : ''}`}>
                    <div className={styles.main_navbar_menu_top}>
                        <div className={styles.logo}>
                            <NavLink to="/"><img src={NavbarLogo} alt="Inery" /></NavLink>
                            <span>Inery DB GUI</span>
                        </div>
                        <button onClick={() => setMenu(false)} className={styles.menu_toggler_btn}>&#10005;</button>
                    </div>
                    <div className={styles.main_navbar_navigation}>
                        {navigationConfig.map((navItem) => (
                            <div key={navItem.id} className={styles.nav_link_bucket}>
                                <NavLink
                                    to={navItem.path}
                                    onClick={() => setMenu(false)}
                                    className={({ isActive }) =>
                                        isActive
                                            ? `${styles.nav_link} ${styles.active}`
                                            : styles.nav_link
                                    }
                                >
                                    {({ isActive }) => (
                                        <>
                                            <navItem.icon color={isActive ? "#239DCE" : dark ? "#757575" : ""} />
                                            <span>{navItem.label}</span>
                                        </>
                                    )}
                                </NavLink>
                            </div>
                        ))}
                    </div>
                    <div className={styles.main_navbar_bottom}>
                        <MainNavbarAccount />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainNavbar;